import { SaltWaterDisposalWellStatusBase } from './base/salt-water-disposal-well-status-base';

export class SaltWaterDisposalWellStatus extends SaltWaterDisposalWellStatusBase { }